import { useContext } from 'react';
import { MobXProviderContext } from 'mobx-react';
import { IFilterParams, IMonthlyOrdersListItem } from '../../interfaces';

export function useMonthlyOrdersTable(): IMonthlyOrdersListItem[] {
    return useContext(MobXProviderContext).RootStore.monthlyOrdersStore.list;
}

export function useMonthlyOrdersFilterParams(): IFilterParams {
    return useContext(MobXProviderContext).RootStore.monthlyOrdersStore.filterParams;
}
